// extracted by mini-css-extract-plugin
export var border = "TextAndImageCardFlat-module--border--7d1df";
export var bordercontainer = "TextAndImageCardFlat-module--bordercontainer--230cc";
export var buttonwrapper = "TextAndImageCardFlat-module--buttonwrapper--9624f";
export var details = "TextAndImageCardFlat-module--details--6f027";
export var image = "TextAndImageCardFlat-module--image--4b148";
export var text = "TextAndImageCardFlat-module--text--f36e0";
export var textandimagecardcontainer = "TextAndImageCardFlat-module--textandimagecardcontainer--a7606";
export var title = "TextAndImageCardFlat-module--title--c9672";